import "../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import { AUTHENTICATOR_KEY } from "../RemediationConstants.js";
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function createOVOptions(options = []) {
  var _ovItem$value, _ovItem$value$form, _ovItem$value$form$va;
  const ovItem = options.find((option) => option.relatesTo.key === AUTHENTICATOR_KEY.OV);
  const methodTypeObj = ovItem === null || ovItem === void 0 ? void 0 : (_ovItem$value = ovItem.value) === null || _ovItem$value === void 0 ? void 0 : (_ovItem$value$form = _ovItem$value.form) === null || _ovItem$value$form === void 0 ? void 0 : (_ovItem$value$form$va = _ovItem$value$form.value) === null || _ovItem$value$form$va === void 0 ? void 0 : _ovItem$value$form$va.find((v) => v.name === "methodType");
  const methodOptions = methodTypeObj === null || methodTypeObj === void 0 ? void 0 : methodTypeObj.options;
  let signedNonceOption;
  if (methodOptions) {
    const ovOptions = [];
    methodOptions.forEach((method) => {
      const value = [...ovItem.value.form.value];
      const methodTypeIndex = ovItem.value.form.value.findIndex((v) => v.name === "methodType");
      const newMethodTypeObj = Object.assign(oktaUnderscore.omit(methodTypeObj, "options"), method);
      newMethodTypeObj.required = true;
      newMethodTypeObj.mutable = false;
      value.splice(methodTypeIndex, 1, newMethodTypeObj);
      const newItem = Object.assign({}, ovItem, {
        label: method.label,
        value: {
          form: {
            value
          }
        }
      });
      if (method.value === "signed_nonce") {
        signedNonceOption = newItem;
      } else {
        ovOptions.push(newItem);
      }
    });
    const ovIndex = options.findIndex((option) => option.relatesTo.key === AUTHENTICATOR_KEY.OV);
    options.splice(ovIndex, 1, ...ovOptions);
    if (signedNonceOption) {
      ovItem.relatesTo.deviceKnown ? options.unshift(signedNonceOption) : options.push(signedNonceOption);
    }
  }
}
function createAuthenticatorOptions(options = []) {
  createOVOptions(options);
  return options.map((option) => {
    var _option$value, _option$value$form, _option$relatesTo;
    const value = ((_option$value = option.value) === null || _option$value === void 0 ? void 0 : (_option$value$form = _option$value.form) === null || _option$value$form === void 0 ? void 0 : _option$value$form.value) || [];
    const valueObject = value.filter((v) => v.required === true && v.mutable === false).reduce((init, v) => {
      return Object.assign(init, {
        [v.name]: v.value
      });
    }, {});
    return {
      label: option.label,
      value: valueObject,
      relatesTo: option.relatesTo,
      authenticatorKey: (_option$relatesTo = option.relatesTo) === null || _option$relatesTo === void 0 ? void 0 : _option$relatesTo.key
    };
  });
}
function getAuthenticatorsEnrollUiSchema({
  options
}) {
  return {
    type: "authenticatorEnrollSelect",
    options: createAuthenticatorOptions(options)
  };
}
function getAuthenticatorsVerifyUiSchema({
  options
}) {
  return {
    type: "authenticatorVerifySelect",
    options: createAuthenticatorOptions(options)
  };
}
function createUiSchemaForObject(ionFormField, remediationForm, transformedResp, createUISchema, settings) {
  const uiSchema = {};
  if (ionFormField.name === "authenticator" && (remediationForm.name === "select-authenticator-authenticate" || remediationForm.name === "select-authenticator-unlock-account")) {
    Object.assign(uiSchema, getAuthenticatorsVerifyUiSchema(ionFormField));
  } else if (ionFormField.name === "authenticator" && remediationForm.name === "select-authenticator-enroll") {
    Object.assign(uiSchema, getAuthenticatorsEnrollUiSchema(ionFormField));
  } else if (Array.isArray(ionFormField.options)) {
    uiSchema.optionsUiSchemas = ionFormField.options.map((opt) => {
      return createUISchema(transformedResp, {
        value: [{
          name: ionFormField.name,
          value: opt.value
        }]
      }, settings);
    });
    uiSchema.options = ionFormField.options.map((opt, index) => {
      return {
        label: opt.label,
        value: index
      };
    });
    uiSchema.type = "radio";
    uiSchema.value = "0";
    uiSchema.name = `sub_schema_local_${ionFormField.name}`;
  }
  return uiSchema;
}
export { createOVOptions, createUiSchemaForObject as default };
